/**
 * Which per-comment actions to show. Edit is author-only. Delete is for the author or a
 * moderator (`project:comment:moderate`: workspace owner, admin, project creator).
 * The backend enforces the same rules; this only decides what the menu offers.
 */
export function commentActionVisibility(params: {
  isAuthor: boolean;
  canComment: boolean;
  readOnly: boolean;
  canModerate: boolean;
}): { canEdit: boolean; canDelete: boolean } {
  const canEdit = params.canComment && !params.readOnly && params.isAuthor;
  const canDelete = !params.readOnly && (canEdit || params.canModerate);
  return { canEdit, canDelete };
}
